import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

const TotalSubscriberOneVolunteers = () => {
    const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
    const [barChartSeries, setBarChartSeries] = useState([]);
    const [barChartOptions, setBarChartOptions] = useState({
        chart: {
            type: "bar",
            height: 264,
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                borderRadius: 6,
                horizontal: false,
                columnWidth: 32, // Increased from 24 to 32 for wider bars
                endingShape: "rounded",
            },
        },
        dataLabels: { enabled: false },
        fill: {
            type: "gradient",
            colors: ["#22C55E"], // Green base color
            gradient: {
                shade: "light",
                type: "vertical",
                shadeIntensity: 0.5,
                gradientToColors: ["#86EFAC"], // Lighter green for gradient
                inverseColors: false,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100],
            },
        },
        grid: {
            show: false,
            borderColor: "#D1D5DB",
            strokeDashArray: 4,
            position: "back",
            padding: {
                top: -10,
                right: -10,
                bottom: -10,
                left: -10,
            },
        },
        xaxis: {
            type: "category",
            categories: [],
        },
        yaxis: { show: true, title: { text: "Volunteer Count" } },
    });

    useEffect(() => {
        const fetchData = async () => {
            const token = localStorage.getItem("token");
            try {
                const response = await fetch(`${API_BASE_URL}/backend/volunteers/region-wise-volunteer-count`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });

                if (response.ok) {
                    const result = await response.json();
                    if (result.status) {
                        const categories = Object.keys(result.data); // ["North", "Central", "South"]
                        const data = Object.values(result.data); // [10, 23, 32]
                        setBarChartOptions(prevOptions => ({
                            ...prevOptions,
                            xaxis: { ...prevOptions.xaxis, categories }
                        }));
                        setBarChartSeries([{ name: "Total Registered Volunteers", data }]);
                    }
                } else {
                    console.error('Failed to fetch data:', response.statusText);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [API_BASE_URL]);

    return (
        <div className="col-xxl-6 col-xl-6">
            <div className="card h-100 radius-8 border">
                <div className="card-body p-24">
                    <h6 className="mb-12 fw-semibold text-lg mb-16">Total Registered Volunteers by Region</h6>
                    <ReactApexChart options={barChartOptions} series={barChartSeries} type="bar" height={264} />
                </div>
            </div>
        </div>
    );
};

export default TotalSubscriberOneVolunteers;